import { Spinner } from "@zapier/design-system";
import styles from "./LoadingTemplateBanner.module.css";

// Be aware: this is being used in multiple locations
export function LoadingTemplateBanner() {
  return (
    <div className={styles.wrapper}>
      <Spinner color="dark" />
    </div>
  );
}
